// extracted by mini-css-extract-plugin
export default {"errorText":"HeaderError_errorText__doBZp","errorContainer":"HeaderError_errorContainer__qM8G0","errorIcon":"HeaderError_errorIcon__FyUQm"};